<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    <h4 class="title is-4">{{createOrUpdate}}</h4>
    <hr />
    <div class="columns">
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Employee</label>
          <span v-if="thirteenMonthPay.thirteenMonthPayId != 0">{{thirteenMonthPay.employee}}</span>
          <div class="control" v-else>
            <b-autocomplete v-model="employeeName" size="is-small" :data="employees" placeholder="Search employees" @select="option => selectedEmployee = option" @input="searchEmployees" :loading="isFetchingEmployees">
              <template slot="empty">
                <span v-if="isFetchingEmployees">
                  Please wait...
                </span>
                <span v-if="employees.length === 0">
                  No results found
                </span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Basic salary</label>
          <div class="control">
            <b-input :loading="isLoadingBasicSalary" type="number" v-model="basicSalary" size="is-small" disabled />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Total month worked (max. 12)</label>
          <div class="control">
            <input type="number" v-model="totalMonthWorked" class="input is-small" v-validate="'required|decimal:2|max_value:12'" name="Total month worked" />
            <span style="font-size:12px" class="has-text-danger">{{ errors.first('Total month worked') }}</span>
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Year</label>
          <div class="control">
            <div class="select is-small">
              <select v-model="thirteenMonthPay.year">
                <option value="2019">2019</option>
                <option value="2020">2020</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Amount</label>
          <div class="control">
            <input type="text" v-model="thirteenMonthPay.amount" class="input is-small" disabled />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Note</label>
          <div class="control">
            <textarea type="text" v-model="thirteenMonthPay.note" class="input is-small" />
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button :class="buttonSave" @click="save">Save</button>
        &nbsp;
        <router-link :to="{name: 'List Of 13 Month Pay'}" class="button is-small">Go back to list</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import debounce from 'lodash/debounce'
import Loading from 'vue-loading-overlay'
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'
import numeral from 'numeral'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  components: {
    Loading
  },
  data: () => ({
    createOrUpdate: 'Create',
    employeeName: '',
    employees: [],
    selectedEmployee: 0,
    isFetchingEmployees: false,
    thirteenMonthPay: {
      thirteenMonthPayId: 0,
      year: 2019,
      amount: 0.0
    },
    basicSalary: 0.0,
    totalMonthWorked: 12,

    isLoading: false,
    isLoadingBasicSalary: false,
    buttonSave: appButton.isLoadingSuccess(false)
  }),
  created() {
    const thirteenMonthPayId = this.$route.params.thirteenMonthPayId
    if (thirteenMonthPayId) {
      this.getById(thirteenMonthPayId)
    }
  },
  methods: {
    searchEmployees: debounce(function() {
      this.isFetchingEmployees = true
      axios
        .get(`api/employees/search-by-name/${this.employeeName}`)
        .then(response => {
          this.employees = response.data
        })
        .catch(error => {
          console.log(error)
        })
        .then(() => {
          this.isFetchingEmployees = false
        })
    }, 500),
    getById(id) {
      if (id) {
        this.isLoading = true
        this.createOrUpdate = '...'
        axios
          .get(`api/thirteenmonthpays/${id}`)
          .then(response => {
            this.thirteenMonthPay = response.data
            this.createOrUpdate = 'Update'
            this.getEmployeeBasicSalaryEmpId(this.thirteenMonthPay.employeeId)
          })
          .catch(error => {
            console.log(error)
            appToast.danger('Something went wrong. Failed to fetch data.')
          })
          .then(() => {
            this.isLoading = false
          })
      }
    },
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.buttonSave = appButton.isLoadingSuccess(true)
          this.thirteenMonthPay.totalMonthWorked = this.totalMonthWorked

          const thirteenMonthPayId = this.thirteenMonthPay.thirteenMonthPayId

          if (thirteenMonthPayId == 0) {
            // CREATE
            axios
              .post(`api/thirteenmonthpays`, this.thirteenMonthPay)
              .then(response => {
                appToast.success(response.data)
                this.$router.push({ name: 'List Of 13 Month Pay' })
              })
              .catch(error => {
                console.log(error)
                appToast.danger(error.response.data)
              })
              .then(() => {
                this.buttonSave = appButton.isLoadingSuccess(false)
              })
          } else {
            // UPDATE
            axios
              .put(
                `api/thirteenmonthpays/${thirteenMonthPayId}`,
                this.thirteenMonthPay
              )
              .then(response => {
                appToast.success(response.data)
                this.$router.push({ name: 'List Of 13 Month Pay' })
              })
              .catch(error => {
                console.log(error)
                appToast.danger(error.response.data)
              })
              .then(() => {
                this.buttonSave = appButton.isLoadingSuccess(false)
              })
          }
        }
      })
    },
    getEmployeeBasicSalaryEmpId(id) {
      if (id) {
        this.isLoadingBasicSalary = true
        axios
          .get(`api/employees/basic-salary/${id}`)
          .then(response => {
            this.basicSalary = response.data
          })
          .catch(error => {
            console.log(error)
            appToast.danger(
              'Something went wrong. Failed to fetch basic salary.'
            )
          })
          .then(() => {
            this.isLoadingBasicSalary = false
          })
      }
    },
    default() {
      this.createOrUpdate = 'Create'
      this.employeeName = ''
      this.employees = []
      this.selectedEmployee = 0
      this.isFetchingEmployees = false
      this.thirteenMonthPay = {
        thirteenMonthPayId: 0,
        year: 2019,
        amount: 0.0
      }
      this.basicSalary = 0.0
      this.totalMonthWorked = 12

      this.isLoading = false
      this.isLoadingBasicSalary = false
      this.buttonSave = appButton.isLoadingSuccess(false)
    },
    calculateAmount() {
      this.thirteenMonthPay.amount = numeral(
        Number(this.basicSalary) * Number(this.totalMonthWorked) / 12
      ).format('0,0.0')
    }
  },
  watch: {
    selectedEmployee() {
      if (this.selectedEmployee) {
        this.getEmployeeBasicSalaryEmpId(this.selectedEmployee.pkey)
        this.thirteenMonthPay.employeeId = this.selectedEmployee.pkey
      } else {
        this.default()
      }
    },
    basicSalary() {
      this.calculateAmount()
    },
    totalMonthWorked() {
      this.calculateAmount()
    }
  }
}
</script>

